import cookies from 'js-cookie'

export const getTokenFromCookie = req => {
  if (!req?.cookies?.token) {
    return cookies.get('token')
  }

  return req.cookies.token
}
